/**
 * @ngdoc module
 * @name flowingly.runner
 * @module flowingly.runner
 * @description Root module for the application
 */
import angular from 'angular';
import './runner.import/runner.import.module';
import './runner.nav.categories/runner.nav.categories.module';
import './runner.directives/runner.directives.module';
import './runner.exago/runner.exago.module';
import './runner.exago.single/runner.exago.single.module';
import './runner.flow/runner.flow/runner.flow.module';
import './runner.flows.active/runner.flows.active.module';
import './runner.flows.imin/runner.flows.imin.module';
import './runner.flows.search/runner.flows.search.module';
import './runner.flows.todo/runner.flows.todo.module';
import './runner.adapters/runner.adapters.module';

import './runner.library/runner.library.module';
import './runner.login/runner.login.module';
import './runner.maintenance/runner.maintenance.module';
import './runner.nav.categories/runner.nav.categories.module';
import './runner.processmapsv2/runner.processmapsv2.module';
import './runner.publicmap/runner.publicmap.module';
import './runner.publicsop/runner.publicsop.module';
import './runner.public-form/runner.public-form.module';
import './runner.redirect/runner.redirect.module';
import './runner.report/runner.report.module';
import './runner.reportsv2/runner.reportsv2.module';
import './runner.services/runner.services.module';
import './runner.setup/runner.setup.module';
import './runner.sso/runner.sso.module';
import './runner.user-condition/runner.user-condition.module';
import './runner.user.accept.invite/runner.user.accept.invite.module';
import './runner.user.notifications/runner.user.notifications.module';
import './runner.user.profile/runner.user.profile.module';
import './signup/signup.module';
import './runner.templates/runner.templates.module';
import './sidemenu/sidemenu.module';
import './usermenu/usermenu.module';
import './runner.governance/runner.governance.module';
import './runner.print/runner.print.module';
import './runner.procedures/runner.procedures.module';
import './runner.smart-search/runner.smart-search.module';
import './runner.creation-hub/runner.creation-hub.module';
const runnerModule = angular.module('flowingly.runner', [
  // Angular
  'ngSanitize',
  'ngMessages',
  'ngCookies',

  // Vendor
  'ui.router',
  'angularSpinner',
  'ui.materialize',
  'fg',
  'fgFiles',
  'ngDialog',
  'angular-storage',
  'ng-currency', // https://github.com/aguirrel/ng-currency (actively worked on in GitHub over the last few years)
  'auth0.lock',
  'angular-jwt',
  'auth0.auth0',
  'ngIdle',
  'mentio',

  // Flowingly Core
  'flowingly.services',
  'flowingly.directives',
  'flowingly.filters',
  'flowingly.adapters',
  'flowingly.directives.sidemenu',
  'flowingly.directives.files',
  'flowingly.components',
  'flowingly.bpmn.modeler',
  'flowingly.modeler.validation',

  // Signup

  'flowingly.signup',
  'flowingly.runner.user.accept.invite',

  // Flowingly Runner
  'flowingly.runner.adapters',
  'flowingly.runner.directives',
  'flowingly.runner.services',
  'flowingly.runner.login',
  'flowingly.runner.flows.active',
  'flowingly.runner.flows.imin',
  'flowingly.runner.flows.search',
  'flowingly.runner.user.notifications',
  'flowingly.runner.user.settings',
  'flowingly.runner.flows.todo',
  'flowingly.runner.flow',
  'flowingly.runner.user.profile',
  'flowingly.runner.reportsv2',
  'flowingly.runner.library',
  'flowingly.runner.setup',
  'flowingly.runner.maintenance',
  'flowingly.runner.nav.categories',
  'flowingly.runner.exago',
  'flowingly.runner.exago.single',
  'flowingly.runner.processmapsv2',
  'flowingly.runner.print',
  'flowingly.runner.publicmap',
  'flowingly.runner.publicsop',
  'flowingly.runner.user.condition',
  'flowingly.runner.sso',
  'flowingly.runner.redirect',
  'flowingly.runner.report',
  'flowingly.runner.import',
  'flowingly.runner.templates',
  'flowingly.runner.public-form',
  'flowingly.runner.governance',
  'flowingly.runner.procedures',
  'flowingly.runner.smart-search',
  'flowingly.runner.formthemes',
  'flowingly.runner.creation-hub'
]);

runnerModule.run([
  '$templateCache',
  function ($templateCache: angular.ITemplateCacheService) {
    $templateCache.put('Client/runner.html', require('./runner.html').default);
  }
]);
export default runnerModule;
